import React from "react";
import { Accordion, Card, Col, Row, Button } from "react-bootstrap";
import NumberFormat from "react-number-format";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import selectThumbnail from "../../../../../img/contact.png";
import { countries } from "../../../../../resources/countries.json";
import ReactCountryFlag from "react-country-flag";

import "./style.scss";
import Text from "../../../../library/text";

const Index = (props) => {
  const dispatch = useDispatch();

  const listId = props.match.params.id;

  const selectedCompany = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );

  const activeContact = useSelector(
    (state) => state.singleContactList.activeDisplay
  );

  const firstName =
    activeContact.general && activeContact.general.firstName
      ? activeContact.general.firstName
      : null;
  const lastName =
    activeContact.general && activeContact.general.lastName
      ? activeContact.general.lastName
      : null;

  const companyName =
    activeContact && activeContact.company.name
      ? activeContact.company.name
      : null;
  const companyPosition =
    activeContact && activeContact.company.position
      ? activeContact.company.position
      : null;

  const email =
    activeContact && activeContact.contact.email
      ? activeContact.contact.email
      : null;
  const phone =
    activeContact && activeContact.contact.phone
      ? activeContact.contact.phone
      : null;
  const website =
    activeContact && activeContact.contact.website
      ? activeContact.contact.website
      : null;

  const facebook =
    activeContact && activeContact.social.facebook
      ? activeContact.social.facebook
      : null;
  const twitter =
    activeContact && activeContact.social.twitter
      ? activeContact.social.twitter
      : null;

  const street =
    activeContact && activeContact.address.street
      ? activeContact.address.street
      : null;
  const postalCode =
    activeContact && activeContact.address.postalCode
      ? activeContact.address.postalCode
      : null;
  const city =
    activeContact && activeContact.address.city
      ? activeContact.address.city
      : null;
  const country =
    activeContact && activeContact.address.country
      ? activeContact.address.country
      : null;

  const thumbnail =
    activeContact && activeContact.logoUrl ? activeContact.logoUrl : null;

  const renderFullName = () => {
    if (firstName || lastName) {
      return `${firstName} ${lastName}`;
    } else {
      return "Ikke tilgjengelig";
    }
  };

  const renderCompanyName = () => {
    if (companyName) {
      return companyName;
    } else {
      return "";
    }
  };

  const renderCompanyPosition = () => {
    if (companyPosition) {
      return companyPosition;
    } else {
      return "";
    }
  };

  const renderCompany = () => {
    if (!companyName && !companyPosition) {
      return "Ingen bedriftsinformasjon";
    } else {
      if (companyName && companyPosition) {
        return `${renderCompanyName()} - ${renderCompanyPosition()}`;
      } else {
        return `${renderCompanyName()} ${renderCompanyPosition()}`;
      }
    }
  };

  const renderEmail = () => {
    if (email) {
      return email;
    } else {
      return "Ikke tilgjengelig";
    }
  };

  const renderPhone = () => {
    if (phone) {
      return phone;
    } else {
      return "Ikke tilgjengelig";
    }
  };

  const renderWebsite = () => {
    if (website) {
      return website;
    } else {
      return "Ikke tilgjengelig";
    }
  };

  const renderFacebook = () => {
    if (facebook) {
      return facebook;
    } else {
      return "Ikke tilgjengelig";
    }
  };

  const renderTwitter = () => {
    if (twitter) {
      return twitter;
    } else {
      return "Ikke tilgjengelig";
    }
  };

  const renderStreet = () => {
    if (street) {
      return street;
    } else {
      return "Ikke tilgjengelig";
    }
  };

  const renderPostalCode = () => {
    if (postalCode) {
      return postalCode;
    } else {
      return "Ikke tilgjengelig";
    }
  };

  const renderCity = () => {
    if (city) {
      return city;
    } else {
      return "Ikke tilgjengelig";
    }
  };

  const renderThumbnail = () => {
    if (thumbnail) {
      return thumbnail;
    } else {
      return selectThumbnail;
    }
  };

  const renderFlag = () => {
    if (country) {
      return <ReactCountryFlag countryCode={country} />;
    }
    return "";
  };

  const renderCountry = () => {
    const details = countries.filter((x) => x.code === country);
    if (details && details.length > 0 && details[0].title) {
      return details[0].title;
    } else {
      return "Ikke tilgjengelig";
    }
  };

  return (
    <div className="single-contact-container">
      <div className="inner-single-contact-container">
        <img
          alt="Ingen kunde"
          className="contact-illustration"
          src={renderThumbnail()}
        />
        <div className="title-container">
          <h2 className="contact-title">
            {renderFullName()} {renderFlag() ? renderFlag() : ""}
          </h2>
        </div>
        <div className="company-container">
          <Text align="center">{renderCompany()}</Text>
        </div>
        <div className="contact-details-container">
          <Accordion className="person-accordion" defaultActiveKey="0">
            <Card className="single-card">
              <Card.Header className="card-header">
                <Accordion.Toggle
                  className="card-toggle"
                  as={Button}
                  variant="link"
                  eventKey="0"
                >
                  Kontaktpunkter <i class="fad fa-chevron-down"></i>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body className="card-body">
                  <Row className="info-row">
                    <Col className="title-col text-left">
                      <label className="label-title">E-postadresse</label>
                    </Col>
                    <Col className="detail-col text-right">
                      <label className="label-detail">{renderEmail()}</label>
                    </Col>
                  </Row>
                  <Row className="info-row">
                    <Col className="title-col text-left">
                      <label className="label-title">Telefon</label>
                    </Col>
                    <Col className="detail-col text-right">
                      <label className="label-detail">{renderPhone()}</label>
                    </Col>
                  </Row>
                  <Row className="info-row">
                    <Col className="title-col text-left">
                      <label className="label-title">Hjemmeside</label>
                    </Col>
                    <Col className="detail-col text-right">
                      <label className="label-detail">{renderWebsite()}</label>
                    </Col>
                  </Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card className="single-card">
              <Card.Header className="card-header">
                <Accordion.Toggle
                  className="card-toggle"
                  as={Button}
                  variant="link"
                  eventKey="1"
                >
                  Sosiale medier <i class="fad fa-chevron-down"></i>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="1">
                <Card.Body className="card-body">
                  <Row className="info-row">
                    <Col className="title-col text-left">
                      <label className="label-title">Facebook</label>
                    </Col>
                    <Col className="detail-col text-right">
                      <label className="label-detail">{renderFacebook()}</label>
                    </Col>
                  </Row>
                  <Row className="info-row">
                    <Col className="title-col text-left">
                      <label className="label-title">Twitter</label>
                    </Col>
                    <Col className="detail-col text-right">
                      <label className="label-detail">{renderTwitter()}</label>
                    </Col>
                  </Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card className="single-card">
              <Card.Header className="card-header">
                <Accordion.Toggle
                  className="card-toggle"
                  as={Button}
                  variant="link"
                  eventKey="2"
                >
                  Addresse <i class="fad fa-chevron-down"></i>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="2">
                <Card.Body className="card-body">
                  <Row className="info-row">
                    <Col className="title-col text-left">
                      <label className="label-title">Gate</label>
                    </Col>
                    <Col className="detail-col text-right">
                      <label className="label-detail">{renderStreet()}</label>
                    </Col>
                  </Row>
                  <Row className="info-row">
                    <Col className="title-col text-left">
                      <label className="label-title">Postnummer</label>
                    </Col>
                    <Col className="detail-col text-right">
                      <label className="label-detail">
                        {renderPostalCode()}
                      </label>
                    </Col>
                  </Row>
                  <Row className="info-row">
                    <Col className="title-col text-left">
                      <label className="label-title">Poststed</label>
                    </Col>
                    <Col className="detail-col text-right">
                      <label className="label-detail">{renderCity()}</label>
                    </Col>
                  </Row>
                  <Row className="info-row">
                    <Col className="title-col text-left">
                      <label className="label-title">Land</label>
                    </Col>
                    <Col className="detail-col text-right">
                      <label className="label-detail">{renderCountry()}</label>
                    </Col>
                  </Row>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </div>
      </div>
      <ReactTooltip />
    </div>
  );
};

export default withRouter(Index);
